import { updateTranslations, updateTranslationsRemote } from 'redux/modules/dynamicLabels/actions';
import store from 'redux/store';
import TranslationServices from 'services/translations/translations';

export const fetchLabels = (language: string) => {
	store.dispatch(updateTranslations(language));
	TranslationServices.fetchTranslations(language).subscribe(
		({ response }) => {
			if (response) store.dispatch(updateTranslationsRemote(response));
		},
		(error: any) => {
			console.log(error);
		}
	);
};
